import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/tNUwkuWAd2acQyqjdygdXd/ChatGPT-Image-2-jul-2026_-08_17_03-p.m..webp';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 bg-brand-cream" data-id="element-95">
      <div className="max-w-3xl mx-auto text-center" data-id="element-96">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-gold/20 border border-brand-gold/40 text-brand-graphite font-bold text-xs sm:text-sm mb-3 shadow-sm" data-id="element-97">
          <span data-id="element-98">✨</span>
          <span data-id="element-99">COMPLETE 6-IN-1 PROFESSIONAL SYSTEM</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-extrabold text-brand-graphite leading-tight mb-3" data-id="element-100">
          The Complete Professional Nutrition System for Nutritionists &amp;
          Dietitians
        </h1>

        <p className="text-base sm:text-lg text-brand-graphite/90 font-medium leading-snug mb-4 max-w-2xl mx-auto" data-id="element-101">
          Save hours creating nutrition plans, organizing client documentation,
          preparing educational materials, and tracking patient progress—without
          building every consultation from scratch.
        </p>

        <div className="inline-block bg-brand-petrol text-white px-4 py-1.5 rounded-md mb-4 shadow-md" data-id="element-102">
          <p className="font-bold text-sm sm:text-base tracking-wide" data-id="element-103">
            NUTRITIONIST PRO™ — 6-in-1 System
          </p>
        </div>

        <div className="mb-5" data-id="element-104">
          <a href="#pricing" className="block cursor-pointer" data-id="element-105">
            <img src={PRODUCT_IMG} alt="Nutritionist Pro 6-in-1 Professional Nutrition System Box Set" className="w-full h-auto object-contain max-w-md sm:max-w-lg mx-auto hover:scale-[1.03] transition-transform duration-300 drop-shadow-2xl" data-id="element-106" />
          </a>
        </div>

        <div className="mb-3" data-id="element-107">
          <CTAButton className="max-w-md mx-auto" data-id="element-108">
            🚀 YES! I WANT MY SYSTEM NOW
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-graphite font-bold" data-id="element-109">
          <div className="flex items-center gap-1" data-id="element-110">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-111" />
            <span data-id="element-112">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-113">•</span>
          <div className="flex items-center gap-1" data-id="element-114">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-115" />
            <span data-id="element-116">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}